import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as classes from './TaxTool.module.scss';
import { businessInformation } from './businesInformation';

const CorpTaxAndPaymentDeadlines = ({ selectedInfo, style }) => {
  return (
    <div className={style}>
      <div className={classes.taxTool_left_align}>
        <p>
          Accounts to Companies House: <span>{selectedInfo.accountsToCompaniesHouse}</span>
        </p>
        <p>
          Corporation Tax: <span>{selectedInfo.corpTaxDue}</span>
        </p>
        <p>
          Tax return due: <span>{selectedInfo.taxReturnDue}</span>
        </p>
      </div>
    </div>
  );
};

const VatReportingAndPaymentDeadlines = ({ selectedInfo, style }) => {
  return (
    <div className={style}>
      <p>
        Due date: <span>{selectedInfo.dueDate}</span>
      </p>
    </div>
  );
};

const pickDefault = (data) => {
  return data.filter((item) => {
    return item.default === true;
  })[0].values;
};

const pickByKey = (data, key) => {
  return data.filter((item) => {
    return item.key === key;
  })[0].values;
};

const displayMap = {
  corporation: CorpTaxAndPaymentDeadlines,
  vat: VatReportingAndPaymentDeadlines
};

const TaxTool = ({ type }) => {
  const widgetType = businessInformation[type];

  const [selectedInfo, setSelectedInfo] = useState(pickDefault(widgetType.data));
  const [selectedValue, setSelectedValue] = useState();

  const handleChange = (event) => {
    setSelectedInfo(pickByKey(widgetType.data, event.target.value));
    setSelectedValue(event.target.value);
  };

  const Display = displayMap[type] || null;

  return (
    <div className={classes.taxTool}>
      <div className={classes.taxTool_heading_and_input}>
        <h3>{widgetType.heading}</h3>
        <div className={classes.taxTool_subheading_and_input}>
          <p>{widgetType.subheading}</p>
          <form>
            <select onChange={handleChange} value={selectedValue}>
              {widgetType.data.map((item) => {
                return (
                  <option key={item.key} value={item.key}>
                    {item.key}
                  </option>
                );
              })}
            </select>
          </form>
        </div>
      </div>
      <div className={classes.taxTool_triangle}></div>
      <Display selectedInfo={selectedInfo} style={classes.taxTool_information} />
    </div>
  );
};

TaxTool.propTypes = {
  type: PropTypes.oneOf(['corporation', 'vat']).isRequired
};

export default TaxTool;
